module.exports = __webpack_public_path__ + "img/27_47.bc4a73db.png";